var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "CruiseHeadOverview" }, [
    _c(
      "div",
      { staticClass: "boat__navigation boat-navigation" },
      [
        _c(
          _setup.OPartLink,
          { attrs: { name: "Route", active: _setup.sectionActive } },
          [_vm._v("Маршрут "), _c("span", [_vm._v("и экскурсии")])]
        ),
        _vm._v(" "),
        _c(
          _setup.OPartLink,
          { attrs: { name: "Overview", active: _setup.sectionActive } },
          [_vm._v("Описание")]
        ),
        _vm._v(" "),
        _c(
          _setup.OPartLink,
          { attrs: { name: "Ship", active: _setup.sectionActive } },
          [_vm._v("Теплоход")]
        ),
        _vm._v(" "),
        _c(
          _setup.OPartLink,
          { attrs: { name: "Promotions", active: _setup.sectionActive } },
          [_vm._v("Акции "), _c("span", [_vm._v("и скидки")])]
        ),
        _vm._v(" "),
        _c(
          _setup.OPartLink,
          { attrs: { name: "Cabins", active: _setup.sectionActive } },
          [_vm._v("Каюты")]
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "boat__serv" },
      [
        _c(
          _setup.OPart,
          { attrs: { name: "Route" } },
          [
            _c("div", { staticClass: "boat__route" }, [
              _c("div", { staticClass: "boat__route-title" }, [
                _vm._v("Маршрут"),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "boat__route-cities" }, [
                _vm._v(_vm._s(_setup.routeFull)),
              ]),
            ]),
            _vm._v(" "),
            _setup.timetable_inf.length
              ? _c(_setup.TimetableInf, {
                  attrs: { timetable: _setup.timetable_inf },
                })
              : _vm._e(),
          ],
          1
        ),
        _vm._v(" "),
        _c(_setup.OPart, { attrs: { name: "Overview" } }, [
          _c("div", { staticClass: "description" }, [
            _c(
              "div",
              { staticClass: "description__header", attrs: { id: "anchor1" } },
              [_vm._v("Описание")]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "description__content" },
              [
                _setup.description.has
                  ? _c(
                      _setup.InsertHtml,
                      _vm._b(
                        { staticClass: "description__text" },
                        "InsertHtml",
                        _setup.description,
                        false
                      )
                    )
                  : _vm._e(),
                _vm._v(" "),
                _setup.included.has
                  ? _c(_setup.IncludedBlock, {
                      attrs: {
                        included: _setup.included,
                        icon: "included",
                        iconClass: "vicon-bluefigma",
                        title: "В стоимость тура входит",
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _setup.excluded.has
                  ? _c(_setup.IncludedBlock, {
                      attrs: {
                        included: _setup.excluded,
                        icon: "excluded",
                        iconClass: "vicon-orange",
                        title:
                          "Дополнительные услуги, не включенные в стоимость",
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _setup.restaurants.has
                  ? _c(_setup.IncludedBlock, {
                      attrs: {
                        included: _setup.restaurants,
                        icon: "restaurants",
                        iconClass: "vicon-bluefigma",
                        title: "Рестораны",
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
          ]),
        ]),
        _vm._v(" "),
        _c(
          _setup.OPart,
          { attrs: { name: "Ship" } },
          [
            _c(_setup.ShipShort, {
              attrs: { ship: _setup.props.CruiseBook.ship },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(_setup.OPart, { attrs: { name: "Promotions" } }, [
          _c("div", { staticClass: "promotions" }, [
            _c("div", { staticClass: "promotions__header" }, [
              _vm._v("Акции и скидки"),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "promotions__content" },
              [
                _c("div", { staticClass: "promotions__text" }, [
                  _vm._v(
                    "\n                        Состав и точное количество скидок уточняйте у менеджера при бронировании криуза. Для получения скидки необходимо предъявить подтверждающие документы.\n                    "
                  ),
                ]),
                _vm._v(" "),
                _c(_setup.Discount, {
                  attrs: {
                    discountob: _setup.discountob,
                    show: true,
                    title: "Акции и скидки",
                  },
                }),
              ],
              1
            ),
          ]),
        ]),
        _vm._v(" "),
        _c(_setup.OPart, { attrs: { name: "Cabins" } }, [
          _c("div", { staticClass: "cabins" }, [
            _c("div", { staticClass: "cabins__header" }, [
              _vm._v("Выбор свободных кают"),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "cabins__content" },
              [
                _c("div", { staticClass: "cabins__text" }, [
                  _vm._v(
                    "\n                        Каюты сгруппированы по расположению и стоимости. Одновременно можно забронировать до 3х кают.\n                    "
                  ),
                ]),
                _vm._v(" "),
                _c(_setup.SelectCabins),
              ],
              1
            ),
          ]),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }